<div>
  <table>
    <tr>
      <td class="gridHeader" *ngFor="let col of gridTitles">
        <span>{{col}}</span>
      </td>
    </tr>
    <tr *ngFor="let row of tankNotifications">
      <td class="gridDetail">
        {{row.userSeverity}}
      </td>
      <td class="gridDetail">
        {{row.message}}
      </td>
      <td class="gridDetail">
        {{row.createdOn_Formatted}}
      </td>
    </tr>

  </table>
</div>
